// 医院是否有中医病历
export const isTCM = function (hospitalID) {
  // console.log(baseOrgan.getbaseInfo().hospitalID, 'baseOrgan')
  return ['27293', '27216', '28923', '28924', '28925', '28250', '28922'].includes(hospitalID)
}

// 医院不关联His
export const disconnectHis = function (hospitalID) {
  // console.log(baseOrgan.getbaseInfo().hospitalID, 'baseOrgan')
  return ['28923', '28924', '28925', '28250'].includes(hospitalID)
}
